import type {DashboardTypes} from '@github-ui/shared-dashboard-sidebar/types/dashboard-types'

import {ISSUES_DEFAULT_VIEW_COOKIE_NAME, PULLS_DEFAULT_VIEW_COOKIE_NAME} from './cookies'

export type DefaultViewDashboardType = Extract<DashboardTypes, 'issues' | 'pull-requests'>

interface DefaultViewConfig {
  analyticsCategory: 'issues-dashboard.click' | 'pull-requests.click'
  cookieName: string
  destinationPath: '/issues' | '/pulls'
  fallbackViewId: 'assigned' | 'inbox'
}

export const defaultViewConfig: Record<DefaultViewDashboardType, DefaultViewConfig> = {
  issues: {
    analyticsCategory: 'issues-dashboard.click',
    cookieName: ISSUES_DEFAULT_VIEW_COOKIE_NAME,
    destinationPath: '/issues',
    fallbackViewId: 'assigned',
  },
  'pull-requests': {
    analyticsCategory: 'pull-requests.click',
    cookieName: PULLS_DEFAULT_VIEW_COOKIE_NAME,
    destinationPath: '/pulls',
    fallbackViewId: 'inbox',
  },
}
